import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeMain from './pages/home-main.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeMain />} />
      </Routes>
    </Router>
  );
}

export default App;
